import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {AccountsListService} from "../ListOfAccounts/AccountsListService";
import {RaikoButtonPrimary, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";
import {TextField} from "@material-ui/core";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../utils/numberConvertor";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";

export default function TransactionsDetail({id, handleUpdateTable}) {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new AccountsListService(fundID, token, snackbar, loading)

    const [amount, setAmount] = useState("");
    const [date, setDate] = useState("");

    useEffect(() => {
        if (id && id !== -1) {

            loading(setLoadingStateDispatch(true))
            service.getMonthlyDepositOfAccountDetail(fundID, id)
                .then(response => {
                    setAmount(response.amount)
                    setDate(convertUniversalDateToPersianDate(response.depositedAt))
                }).catch(reason => {
                showServerError(reason)
            }).finally(_ => {
                loading(setLoadingStateDispatch(false))
            })

        }
    }, [id]);


    function showServerError(reason) {
        if (reason.response && reason.response.data.message)
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, reason.response.data.message))
        else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطایی رخ داده، لطفا مجددا تلاش نمایید."))
    }

    function handleUpdateTransaction() {
        if (date.length === 10) {
            loading(setLoadingStateDispatch(true))
            service.updateNewMonthlyDeposit(fundID, id, amount, date)
                .then(response => {
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی با موفقیت انجام شد."))
                    handleUpdateTable()
                }).catch(reason => {
                showServerError(reason);
            }).finally(_ => {
                loading(setLoadingStateDispatch(false))
            })
        } else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا تاریخ را به درستی وارد نمایید"))
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <TextField
                dir="ltr"
                className='w-100'
                variant="outlined"
                value={convertCurrencyFormat(amount)}
                onChange={e => {
                    const amount = e.target.value.replaceAll(",", "")
                    e.target.value = amount === "" ? "" : convertCurrencyFormatPositiveNegative(amount)
                    setAmount(amount)
                }}
                label="مبلغ(ریال)"/>

            <TextField
                value={convertToBirthDate(date)}
                onChange={e => {
                    setDate(convertToBirthDate(e.target.value))
                }}
                className={'w-100'}
                variant={"outlined"}
                label={"تاریخ پرداخت"}
            />

            <div
                className={
                    css`
                      width: 100%;
                      display: flex;
                      justify-content: end;
                    `}
            >
                <RaikoButtonPrimary
                    label={"بروزرسانی"}
                    onClick={_ => {
                        handleUpdateTransaction()
                    }}
                />
            </div>
        </RaikoGridOneColumn>
    )

}
